export default `<g fill="none"
stroke="currentColor"
stroke-width="2"
stroke-linecap="round"
stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline> </g>`;
